import React, { Fragment, useEffect } from "react";
import classes from "./couponCode.module.css";
import { useToasts } from "react-toast-notifications";
import { useCouponCode } from "../../../../Pregrine/CartPage/PriceAdjustments/CouponCode/useCouponCode";

const CouponCode = (props) => {
  const talonProps = useCouponCode({
    setIsCartUpdating: props.setIsCartUpdating,
  });
  const { addToast } = useToasts();
  const { setCouponCodeText } = props;
  const {
    applyingCoupon,
    data,
    handleApplyCoupon,
    handleRemoveCoupon,
    removingCoupon,
    setCouponCode,
    couponCode,
    fetchError,
    applyError,
    removeCouponError,
    isValidCouponCode,
    couponCodeError,
  } = talonProps;

  useEffect(() => {
    if (removeCouponError && removeCouponError.message) {
      addToast(removeCouponError.message, {
        appearance: "error",
        autoDismiss: true,
        style: {
          backgroundColor: "#DB1F00",
          color: "#fff",
        },
      });
    }
  }, [addToast, removeCouponError]);

  useEffect(() => {
    if (!data) return;
    if (data?.cart?.applied_coupons) {
      setCouponCodeText(data?.cart?.applied_coupons[0].code);
    }
  }, [data]);

  if (!data) {
    return null;
  }

  if (fetchError && fetchError.message) {
    return <span>{fetchError.message}</span>;
  }

  if (data.cart.applied_coupons) {
    const codes = data.cart.applied_coupons.map(({ code }) => {
      return (
        <Fragment key={code}>
          <span>{code}</span>
          <button
            className={classes.applybtn}
            disabled={removingCoupon}
            onClick={() => {
              handleRemoveCoupon(event, code);
            }}
          >
            <span>Remove</span>
          </button>
        </Fragment>
      );
    });

    return (
      <>
        <div className={classes.appliedCoupon}>{codes}</div>
        <hr />
      </>
    );
  } else {
    const errorMessage = applyError && applyError.message;

    return (
      <>
        <form
          onSubmit={handleApplyCoupon}
          className={`${classes.form} d-flex pt-3`}
        >
          <input
            className={classes.inptfld}
            name="CouponCode"
            placeholder="Enter Coupon Code"
            type="text"
            onChange={(e) => setCouponCode(e.target.value)}
            value={couponCode}
            // onBlur={isValidCouponCode}
          />
          <input
            className={classes.applybtn}
            value="Apply"
            disabled={applyingCoupon}
            type="submit"
          />
        </form>
        <div className="row">
          <div
            className={`text-left text-small col-md-12 ${classes.color_red}`}
          >
            {errorMessage ? errorMessage : couponCodeError}
          </div>
        </div>
        <hr />
      </>
    );
  }
};

export default CouponCode;
